<template>
  <div id="DataService">
    <div id="DataService-top"></div>
    <div id="DataService-body">
      <p class="DataService-title">数据服务</p>
      <div class="DataService-content">
        <div class="DataService-content-item1">
          <img src="../../assets/images/ProductAndService/DataService/MultipleDataSources.png"/>
          <p>支持多种数据源</p>
          <ul>
            <li>
              <a class="DataService-content-text-before"></a>
              <a class="DataService-content-text">非结构化数据</a>
            </li>
            <li>
              <a class="DataService-content-text-before"></a>
              <a class="DataService-content-text">纸质数据录入</a>
            </li>
            <li>
              <a class="DataService-content-text-before"></a>
              <a class="DataService-content-text">检测报告数据</a>
            </li>
          </ul>
        </div><!--
     --><div class="DataService-content-item2">
          <img src="../../assets/images/ProductAndService/DataService/DataAnalysis.png"/>
          <p>数据分析计算</p>
          <ul>
            <li>
              <a class="DataService-content-text-before"></a>
              <a class="DataService-content-text">数据计算模型</a>
            </li>
            <li>
              <a class="DataService-content-text-before"></a>
              <a class="DataService-content-text">AI图像识别</a>
            </li>
            <li>
              <a class="DataService-content-text-before"></a>
              <a class="DataService-content-text">数据清洗</a>
            </li>
          </ul>
        </div><!--
     --><div class="DataService-content-item3">
          <img src="../../assets/images/ProductAndService/DataService/DataVisualization.png"/>
          <p>专业级数据可视化</p>
          <ul>
            <li>
              <a style="margin-bottom:10px;" class="DataService-content-text-before"></a>
              <a class="DataService-content-text">专精于儿童健康数据可视化</a>
            </li>
            <li>
              <a style="margin-bottom:10px;" class="DataService-content-text-before"></a>
              <a class="DataService-content-text">提供丰富行业模板和图表组件优化展示</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss">
#DataService-top{
  height: 600px;
  background-size: auto 100%;
  background-position:center;
  background-repeat: no-repeat;
  background-image: url(../../assets/images/ProductAndService/DataService/DataService_Banner.png);
}
#DataService-body{
  padding-top: 60px;
  padding-bottom: 60px;
}
#DataService-body .DataService-title{
  font-size: 36px;
  color: #282828;
}
#DataService-body .DataService-content{
  margin-top: 41px;
}
#DataService-body .DataService-content .DataService-content-item1,.DataService-content-item2,.DataService-content-item3{
  text-align: left;
  vertical-align: top;
}
#DataService-body .DataService-content .DataService-content-item1{
  margin-right: 188px;
  margin-top: 7px;
}
#DataService-body .DataService-content .DataService-content-item3{
  margin-left: 190px;
  margin-top: 4px;
}
#DataService-body .DataService-content a{
  line-height: 22px;
}
#DataService-body .DataService-content p{
  font-size: 18px;
  margin-bottom: 24px;
  color: #909090;
}
#DataService-body .DataService-content .DataService-content-item1 p{
  margin-top: 4px;
}
#DataService-body .DataService-content .DataService-content-item2 p{
  margin-top: 15px;
}
#DataService-body .DataService-content .DataService-content-item3 p{
  margin-top: 17px;
}
#DataService-body .DataService-content div{
  display: inline-block;
}
#DataService-body .DataService-content div li{
  width: 148px;
  text-align: left;
}
#DataService-body .DataService-content div .DataService-content-text{
  font-size: 14px;
  color: #909090;
}
#DataService-body .DataService-content div .DataService-content-text-before{
    width: 6px;
    height: 6px;
    float: left;
    margin-top: 9px;
    margin-right: 9px;
    background-color: #909090;
    -moz-border-radius: 3px;
    -webkit-border-radius: 3px;
    border-radius: 3px;
}
</style>



// WEBPACK FOOTER //
// src/pages/ProductAndService/DataService.vue